import React from 'react';
import { Flex, Text } from '@smarterservices/smarter-ui';
import SinglePane from '../SinglePane';

const ExtensionNonResponsive = ({ step }) => {
  return (
    <SinglePane>
      <Flex
        direction="column"
        height="100%"
        justifyContent="center"
        alignItems="center"
        padding="medium"
      >
        <Text size="large">{step?.stepData?.message}</Text>
      </Flex>
    </SinglePane>
  );
};

export default ExtensionNonResponsive;